module.exports = __webpack_public_path__ + "static/media/handbags_4_getty_mobile.af686277.jpg";